import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomAlert } from '../customAlert';
import { SaveFormBottomProps } from './formTypes';

export const SaveFormBottom = (props: SaveFormBottomProps) => {
  const BottomComponentBar = props.bottomBar;
  const { t } = useTranslation();
  const canSave = useMemo(() => {
    const isDirty = props.isDirty === undefined ? true : props.isDirty;
    const isValid = props.isValid === undefined ? true : props.isValid;
    return isDirty && isValid;
  }, [props.isDirty, props.isValid]);
  const [alertVisible, setAlertVisible] = useState(false);
  const showAlert = () => setAlertVisible(true);
  const hideAlert = () => setAlertVisible(false);

  const handleConfirmedCancel = () => {
    hideAlert();

    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    <>
      {props.children}
      <BottomComponentBar
        title={props.title}
        onRightPress={props.onResetForm}
        onSave={props.onSave || props.onSubmit}
        rightPressDisabled={!canSave}
        confirmBack={props.isDirty && !alertVisible}
        showAlert={showAlert}
        additionalHeaderBlock={props.additionalHeaderBlock}
        backButtonLabel={props.backButtonLabel}
        saveLabel={props.saveLabel}
        onCancel={props.onCancel}
      />
      <CustomAlert
        visible={alertVisible}
        hideAlert={hideAlert}
        action={handleConfirmedCancel}
        title={t('topNav.customAlert.exit')}
        primaryButtonLabel={t('topNav.customAlert.yes')}
        secondaryButtonLabel={t('topNav.customAlert.cancel')}
        tertiaryButtonLabel={
          props.showSaveDraftButton
            ? t('topNav.customAlert.saveProgress')
            : undefined
        }
        tertiaryAction={props.onSaveDraft}
      />
    </>
  );
};
